import App from './App.svelte';

const target = document.body;

target.innerHTML = '';

const app = new App({
	target,
	props: {
		name: 'world',
	},
});

export default app;
